<template lang="pug">
    section#banner
        .wrapper
            h1 Vestibular
            p
                |Um Centro Universitário que está há mais de 20 anos no mercado educacional e tem
                |credibilidade internacional por fazer parte da rede
                |americana Vanta Education. Essa é a escolha certa para confiar seu futuro
                |no mercado de trabalho.
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
